import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TOK_PAYMENT } from '../../constants/route.constants';

@Component({
  selector: 'app-tok-complete-modal',
  templateUrl: './tok-complete-modal.component.html',
})
export class TokCompleteModalComponent {
  @Input() petName: string;

  constructor(public activeModal: NgbActiveModal, private router: Router) {}

  /**
   * Sends the keeper to the payment page rather than checking out here: multi-plan TOK requests
   * (Rescue, BasePlusBreederSale) offer a choice of plans, and that page owns the plan selection,
   * backend pricing and product availability.
   */
  public completeTok(): void {
    this.activeModal.dismiss();
    this.router.navigate([`/${TOK_PAYMENT}`], { queryParams: { petName: this.petName } });
  }
}
